import ReducerUtils   from "../../../utils/ReducerUtils"
import Actions        from "../../../model/constant/actions"

const RetrieveDecisionsAfterSaving = ReducerUtils.createReducer<boolean>(false,{
  [Actions.RETRIEVE_PACY_DECISIONS_AFTER_SAVING] : (state,action)=>action.status
})

export default RetrieveDecisionsAfterSaving
